import { AIRPORT_CODE_PATTERN } from 'hooks/useAirspaceSummary/hooks/useNormalize/patterns';
import type { AirspaceRestriction } from 'hooks/useAirspaceSummary/types';
import type { AirspaceWeather } from 'hooks/useAirspaceWeather/types';

// CONUS METAR stations use a K prefix (KUAO, KPDX, KHIO). Airport cards use
// the FAA 3-letter identifier without the prefix (UAO, PDX, HIO). Strip the
// K so "KUAO" matches the "(UAO)" code in the card name.
const CONUS_ICAO_PREFIX = /^K/;

export const extractAirportCode = (name: string): string | null =>
    name.match(AIRPORT_CODE_PATTERN)?.[1] ?? null;

export const normalizeStation = (station: string): string => station.replace(CONUS_ICAO_PREFIX, '');

export const findWeatherMatchKey = (
    restrictions: AirspaceRestriction[],
    weather: AirspaceWeather | null
): string | null => {
    if (weather?.droneWeather === null || weather?.droneWeather === undefined) {
        return null;
    }

    const station = normalizeStation(weather.droneWeather.station);

    for (const restriction of restrictions) {
        const code = extractAirportCode(restriction.name);

        if (code !== null && code === station) {
            return `${restriction.layer}:${code}`;
        }
    }

    return null;
};

export const buildRestrictionWeatherKey = (restriction: AirspaceRestriction): string | null => {
    const code = extractAirportCode(restriction.name);

    return code === null ? null : `${restriction.layer}:${code}`;
};
